import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Reports } from '../reports.model';
import { ReportsService } from '../reports.service';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Globle } from 'src/assets/globle';
import { ExportexcelService } from '../exportexcel.service';

@Component({
  selector: 'app-ordersreports',
  templateUrl: './ordersreports.component.html',
  styleUrls: ['./ordersreports.component.css']
})
export class OrdersreportsComponent implements OnInit {

  reports: Reports[] = [];
  displayedColumns: string[] = ['orderId', 'userName', 'userCatg', 'category', 'subCategory', 'product',
    "quantity", "total", "date", "CardsNumber"];
  dataSource!: MatTableDataSource<Reports>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false
  lang = 'en';
  reportObj: Reports = {} as Reports
  pageSize = 100;
  searchByName: string = "";
  constructor(private service: ReportsService,
    private translate: TranslateService,
    private excelService: ExportexcelService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAllByDate(this.fromDate.nativeElement.value, this.toDate.nativeElement.value, this.searchByName).subscribe(data => {
      this.reports = data;
      // if (obj.length > 0) {

      //   for (let i = 0; i < obj.length; i++) {
      //     this.reportObj = {} as Reports;
      //     this.reportObj.userName = obj[i]['userName'];
      //     this.reportObj.userCategory = obj[i]['userCategory'];
      //     this.reportObj.categoryName = obj[i]['categoryName'];
      //     this.reportObj.subCategoryName = obj[i]['subCategoryName'];
      //     this.reportObj.productName = obj[i]['productName'];
      //     this.reportObj.quantity = obj[i]['quantity'];
      //     this.reportObj.total = obj[i]['total'];

      //     var date = new Date(obj[i]['date']);
      //     this.reportObj.date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      //     this.reports.push(this.reportObj);
      //   }
      // }
      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  Print() {

    const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

    doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
    doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

    doc.setFont("Amiri");

    doc.setFontSize(18);
    doc.setTextColor(40);
    //doc.setFont("",'normal');

    doc.text("كشف طلبات كلي ", 90, 10);
    doc.text("_________________________________", 50, 12);


    if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
      && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
      doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
        isOutputRtl: true
      });
      doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
        isOutputRtl: true
      });
    }

    //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    autoTable(doc, { html: '#ordersTable', margin: { top: 30 }, styles: { font: "Amiri" } });
    //doc.save("test.pdf");
    doc.output('dataurlnewwindow');
  }

  getTotalCost() {
    return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var productCards = "";
      this.reports[i].productCards.forEach((item: any) => {
        productCards += item
      })
      var obj = {
        "رقم الطلب": this.reports[i].orderId,
        "اسم المستخدم": this.reports[i].userName,
        "فئة المستخدم": this.reports[i].userCategory,
        "المنتج ": this.reports[i].categoryName + " - " + this.reports[i].subCategoryName + " - "
          + this.reports[i].productName,
        "الكمية": this.reports[i].quantity,
        "التاريخ": this.reports[i].date,
        "المجموع": this.reports[i].total,
        "ارقام البطاقات": productCards
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'تقرير مبيعات فترة');
  }
}
